<template>
  <section >
    
    <v-parallax src="/static/Capa7.png" height="200">
      <v-flex  class="text-xs-right mr-5 mt-5 pt-5">
        
      </v-flex>
    </v-parallax>

    <!-- Unidades  -->
    <v-layout row wrap class="ml-5 mr-5">
    <v-flex xl3 offset-xl0  lg3 offset-lg0  md4 offset-md0  xs10 offset-xs1  sm10 offset-sm1 >
      <form>
        <v-card flat class="color-primary mt-3">
          <v-toolbar flat dark color="transparent" class="">
            <v-toolbar-title  class="white--text"><v-icon large color="white">add</v-icon> Agregar Unidad</v-toolbar-title>

          </v-toolbar>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-layout wrap class="pl-3  pb-3 pr-3 "> 
                  <v-flex xs12>
                  <v-text-field 
                  label="Nombre"
                  v-model="unidad.unity_name"
                  :counter="50"
                  required
                  color="white"
                  class="white--text"
                  dark
                  ></v-text-field>
                  </v-flex> 
                  <v-flex xs12>
                    <v-text-field
                    label="Descripción"
                    v-model="unidad.unity_description"
                    multi-line
                    rows="4"
                    class="white--text"
                    dark
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                  <v-text-field
                  label="Posicion"
                  v-model="unidad.unity_orden"
                  :counter="3"
                  required
                  class="white--text"
                  dark
                  ></v-text-field>
                  </v-flex>

                  <v-flex  xs1> 
                   <v-btn  flat color="white"  @click="submitUnidad(unidad)" >Agregar</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card>
        </form>
      </v-flex>
      <v-flex xl8 offset-xl1 lg8 offset-lg1 md7 offset-md1 xs12 offset-xs0 sm8 offset-sm2 class="" >
            <v-toolbar flat dark color="transparent">
              <v-toolbar-title  class="color-primary-letra">Unidades</v-toolbar-title>
            </v-toolbar>
        
             <v-layout  row wrap >
              <v-flex xl1 lg1 md1 xs12 sm12  >
                <p class="text-xs-center color-primary-letra title" >Nº</p>
              </v-flex>
              <v-flex xl3 lg3 md3 xs12 sm12  >
                <p class="text-xs-center color-primary-letra title" >Unidad</p>
              </v-flex>
              <v-flex xl7 lg7 md7 xs12 sm12 class="ml-2" >
                <p class="text-xs-center color-primary-letra title" >Descripción</p>
              </v-flex> 
             </v-layout>

            <v-container 
              style="max-height: 380px; padding: 0px"
              class="scroll-y"
              id="scroll-target"
            >

                  <v-layout class="" row wrap v-for="unidad in unidades"   :key="unidad.id" >
                    <v-flex xl4 lg4 md4 xs12 sm12 class="color-primary pt-3 mb-3"  >
                      <v-layout row wrap>
                        <v-flex xl3 lg3 md3 xs3 sm3  >
                          <p class="white--text text-xs-center subheading">{{ unidad.unity_orden }}</p>
                        </v-flex>
                        <v-flex  xl9 lg9 md9 xs9 sm9  >
                          <p class="white--text text-xs-left subheading">{{ unidad.unity_name }}</p>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex  xl7 offset-xl1 lg7  md7  xs11  sm12  class="color-primary ml-2 pt-3 pl-5 pr-5 mb-3">
                        <p class="white--text text-xs-left   subheading">{{ unidad.unity_description }}</p>
                        <v-flex xl6 offset-xl3 lg7 offset-lg3 md12 offset-md0 xs12  sm12  class="pl-4">
                          <v-btn class="btn-table" color="white" fab small dark @click="nuevaLeccion(unidad.id)" slot="activator" >

                            <v-icon color="orange darken-4">remove_red_eye</v-icon>
                          </v-btn>
                          <v-btn class="btn-table " color="white" fab small dark @click="setCurrent()" slot="activator" @click.native.stop="dialogEditar = true">
                            <v-icon color="orange darken-4">edit</v-icon>
                          </v-btn>
                          <v-btn class="btn-table" color="white" fab small dark @click="dlgEliminarTicket = true; ticketDelete = props.item.id" slot="activator">
                            <v-icon color="orange darken-4">delete</v-icon>
                          </v-btn>
                        </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    column
                    align-center
                    justify-center
                    v-scroll="{
                      target: '#scroll-target',
                      callback: this.onScroll
                    }"
                    style="height: auto"
                  >
                  </v-layout>
                </v-container>
           

      </v-flex> 

</v-layout>
  </section>
</template>

<script>
import { unidadService } from '@/services/Unidad.service'
import { getAllUnityOfCurseService } from '@/services/GetAllUnityOfCurse.service'
export default {
  data () {
    return {
      idCurso: 0,
      offsetTop: 0,
      levels: [],
      editable: true,
      specialty: [],
      unidades: [],
      unidad: {},
      lecciones: [],
      pagination: {},
      title: '',
      valid: true,
      dialogCrearUnity: false,
      headers: [
        {
          text: '#',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Unidad', value: 'unidad' },
        { text: 'Descripción', value: 'descriocion' },
        { text: '', value: '' }
      ]
    }
  },
  methods: {
    loadUnidades (id) {
      let vm = this
      getAllUnityOfCurseService.getById(id).then(data => {
        vm.unidades = data.body
      })
    },
    editar () {
      this.editable = false
    },
    submitUnidad (model) {
      let vm = this
      model.course_id = vm.idCurso
      unidadService.save(model).then(data => {
        vm.unidades = data.body
        vm.dialogCrearUnity = false
      }, response => {
      })
    },
    nuevaLeccion (id) {
      this.$router.push({name: 'contentUnity', params: {id: id}})
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.loadUnidades(vm.idCurso)
  }
}
</script>

<style scoped>

.header-card{

}

.toolbar-misCursos{
  padding: 0.2em;
  margin: 0.5em;


}

.expansion-panel__header {
  padding: 0px !important;
}

.color-primary{
  background-color: #EB6330;
}


.color-primary-letra{
  color: #EB6330;
}

</style>




// WEBPACK FOOTER //
// src/components/Unidad/UnidadPerCurso.vue